import {Button, Card, Col, Drawer, Form, message, Modal, Row, Space, Spin, Table} from "antd";
import React, {JSXElementConstructor, ReactElement, ReactNode, ReactPortal, useEffect, useRef, useState} from "react";
import {JointAccountTemplateAdminDto} from "../../../dto/admin/JointAccountTemplateAdminDto";
import {DownloadOutlined, ExclamationCircleOutlined, EyeOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import {
    DOC_CODE_INVEST_TRANSACTION_DOCUMENT,
    NOT_AVAILABLE,
    PREVIEW_DOC_TYPES,
    YYYY_MM_DD,
    YYYY_MM_DD_HH_MM
} from "../../../util/Constants";
import TableSearchComp from "../../common/tableSearch/TableSearchComp";
import transactionFetchService from "../../../service/transactionFetchService";
import {
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_MANUALLY_MAPPED_CUSTOMER_REQUEST_ERROR,
    MSG_FAILED_TO_FETCH_PENDING_TRANSACTION_LIST_ERROR,
    MSG_MANUAL_RECONCILE_AUTHORIZE_FAILURE,
    MSG_MANUAL_RECONCILE_AUTHORIZE_SUCCESS,
    MSG_MANUAL_RECONCILE_REJECT_SUCCESS,
    MSG_MANUAL_RECONCILE_REJECTION_FAILURE, MSG_UNABLE_TO_FETCH_INVEST_DOCUMENTS_ERROR
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {AccountWiseFundDetailDto} from "../../../dto/AccountWiseFundDetailDto";
import {ReconciliationTableDataDto} from "../../../dto/admin/ReconciliationTableDataDto";
import {TableColumnsType} from "antd/lib/table";
import TextArea from "antd/es/input/TextArea";
import documentService from "../../../service/documentService";
import {toNumber} from "lodash";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import CommonFunction from "../../../util/CommonFunction";
import PreviewModalComp from "../../common/preview/PreviewModalComp";
import modal from "antd/es/modal";
import {ManualReconciliationDto} from "../../../dto/admin/ManualReconciliationDto";
import transactionService from "../../../service/transactionService";
import {recon_auth} from "../../../../AppImageConst";
import Draggable, {DraggableData, DraggableEvent} from "react-draggable";

const INDIVIDUAL = "INDIVIDUAL";
const BULK = "BULK";
const InvestReconciliationAuth = () => {
    const [manualReconcileList, setManualReconcileList] = useState<JointAccountTemplateAdminDto[]>([]);
    const [isTableLoading, setTableLoading] = useState(false);
    const [isRejectReasonModalOpen, setRejectReasonModalOpen] = useState(false);
    const [isSpinning, setSpinning] = useState(false);
    const [selectedRecordIdList, setSelectedRecordIdList] = useState<number[]>([]);
    const [openPendingTransDrawer, setPendingTransOpen] = useState(false);
    const [isCustomerRequestLoading, setCustomerRequestLoading] = useState(false);
    const [isColumnHide, setColumnHide] = useState(false);
    const [selectedRecordList, setSelectedRecordList] = useState<ReconciliationTableDataDto[]>([]);
    const [customerRequestList, setCustomerRequestList] = useState<AccountWiseFundDetailDto[]>([]);
    const [isTransReceiptModalOpen, setIsTransReceiptModalOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [documentName, setDocumentName] = useState<string>("Transaction Receipt");
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>();
    const [bounds, setBounds] = useState({left: 0, top: 0, bottom: 0, right: 0});
    const draggleRef = useRef<HTMLDivElement>(null);
    const [disabled, setDisabled] = useState(true);
    const toFixed = (value: string | undefined): any => {
        if (undefined != value) {
            let val = value.toString();
            if (val.indexOf(".") != -1) {
                val = val.slice(0, (val.indexOf(".")) + 3);
            }
            val = (+val).toFixed(2);
            return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return "0.00";
    }

    const columns = [

        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            sorter: (a: any, b: any) => {
                a = a.date == null ? '' : a.date
                b = b.date == null ? '' : b.date
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Portfolio ID',
            dataIndex: 'portFolioId',
            sorter: (a: any, b: any) => {
                a = a.portFolioId == null ? '' : a.portFolioId
                b = b.portFolioId == null ? '' : b.portFolioId
                return a.localeCompare(b);
            },
            ...TableSearchComp('portFolioId', 'Portfolio ID'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Fund',
            dataIndex: 'fund',
            sorter: (a: any, b: any) => {
                a = a.fund == null ? '' : a.fund
                b = b.fund == null ? '' : b.fund
                return a.localeCompare(b);
            },
            ...TableSearchComp('fund', 'Fund'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Amount',
            dataIndex: 'value',
            align: 'right',
            sorter: (a: any, b: any) => a.value - b.value,
            ...TableSearchComp('value', 'Amount'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{toFixed(text)}</span>)
            }

        },
        {
            title: 'Collection Bank',
            dataIndex: 'collectionBank',
            sorter: (a: any, b: any) => {
                a = a.collectionBank == null ? '' : a.collectionBank
                b = b.collectionBank == null ? '' : b.collectionBank
                return a.localeCompare(b);
            },
            ...TableSearchComp('collectionBank', 'Collection Bank'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'NIC No.',
            dataIndex: 'nic',
            sorter: (a: any, b: any) => {
                a = a.nic == null ? '' : a.nic
                b = b.nic == null ? '' : b.nic
                return a.localeCompare(b);
            },
            ...TableSearchComp('nic', 'NIC No.'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Reconciled Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            sorter: (a: any, b: any) => {
                a = a.createdDate == null ? '' : a.createdDate
                b = b.createdDate == null ? '' : b.createdDate
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Reconciled By',
            dataIndex: 'authAdmin',
            sorter: (a: any, b: any) => {
                a = a.authAdmin == null ? '' : a.authAdmin
                b = b.authAdmin == null ? '' : b.authAdmin
                return a.localeCompare(b);
            },
            ...TableSearchComp('authAdmin', 'Reconciled By'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            fixed: 'right' as const,
            hidden: isColumnHide,
            render: (text: any, rec: any) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view'
                            icon={<EyeOutlined/>} onClick={() => onView(rec)}>View</Button>

                </Space>
            ),
        },
    ].filter(item => !item.hidden);

    const customerRequestsColumns: TableColumnsType<AccountWiseFundDetailDto> = [
        {
            title: 'CIN',
            dataIndex: 'customerCin',
            sorter: (a: any, b: any) => {
                a = a.customerCin == null ? '' : a.customerCin
                b = b.customerCin == null ? '' : b.customerCin
                return a.localeCompare(b);
            },
            ...TableSearchComp('customerCin', 'CIN'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Customer Name',
            dataIndex: 'customerName',
            sorter: (a: any, b: any) => {
                a = a.customerName == null ? '' : a.customerName
                b = b.customerName == null ? '' : b.customerName
                return a.localeCompare(b);
            },
            ...TableSearchComp('customerName', 'Customer Name'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'NIC No.',
            dataIndex: 'customerNic',
            sorter: (a: any, b: any) => {
                a = a.customerNic == null ? '' : a.customerNic
                b = b.customerNic == null ? '' : b.customerNic
                return a.localeCompare(b);
            },
            ...TableSearchComp('customerNic', 'NIC No.'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Portfolio ID',
            dataIndex: 'portfolioNumber',
            sorter: (a: any, b: any) => {
                a = a.portfolioNumber == null ? '' : a.portfolioNumber
                b = b.portfolioNumber == null ? '' : b.portfolioNumber
                return a.localeCompare(b);
            },
            ...TableSearchComp('portfolioNumber', 'Portfolio ID'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Fund',
            dataIndex: 'fundName',
            sorter: (a: any, b: any) => {
                a = a.fundName == null ? '' : a.fundName
                b = b.fundName == null ? '' : b.fundName
                return a.localeCompare(b);
            },
            ...TableSearchComp('fundName', 'Fund'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Amount',
            dataIndex: 'fundAmount',
            align: 'right',
            sorter: (a: any, b: any) => a.fundAmount - b.fundAmount,
            ...TableSearchComp('fundAmount', 'Amount'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{toFixed(text)}</span>)
            }

        },
        {
            title: 'Collection Bank',
            dataIndex: 'collectionBank',
            sorter: (a: any, b: any) => {
                a = a.collectionBank == null ? '' : a.collectionBank
                b = b.collectionBank == null ? '' : b.collectionBank
                return a.localeCompare(b);
            },
            ...TableSearchComp('collectionBank', 'Collection Bank'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Ref. No.',
            dataIndex: 'transactionRefNo',
            sorter: (a: any, b: any) => {
                a = a.transactionRefNo == null ? '' : a.transactionRefNo
                b = b.transactionRefNo == null ? '' : b.transactionRefNo
                return a.localeCompare(b);
            },
            ...TableSearchComp('transactionRefNo', 'Ref. No.'),
            render: (text: any, rec: any, index: number) => {
                return (<span>{text ? text : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Started Date',
            dataIndex: 'startedDate',
            key: 'startedDate',
            sorter: (a: any, b: any) => {
                a = a.startedDate == null ? '' : a.startedDate
                b = b.startedDate == null ? '' : b.startedDate
                return a.localeCompare(b);
            },
            ...TableSearchComp('startedDate', 'Started Date'),
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD) : NOT_AVAILABLE}</span>
            )

        },
        {
            title: 'Process Date',
            dataIndex: 'processDate',
            key: 'processDate',
            sorter: (a: any, b: any) => {
                a = a.processDate == null ? '' : a.processDate
                b = b.processDate == null ? '' : b.processDate
                return a.localeCompare(b);
            },
            ...TableSearchComp('processDate', 'Process Date'),
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Trans. Receipt',
            dataIndex: 'tr_receipt',
            key: 'tr_receipt',
            align: 'center',
            fixed: 'right' as const,
            render: (text: any, rec: AccountWiseFundDetailDto) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            icon={<EyeOutlined/>} onClick={() => showTransReceiptModal(rec)}>View</Button>
                </Space>
            ),
        },
    ];
    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: AccountWiseFundDetailDto[]) => {
            setSelectedRecordIdList(selectedRowKeys as number[]);
        },

    };

    useEffect(() => {
        fetchManualReconciliationList()
    }, []);
    const fetchManualReconciliationList = () => {
        setTableLoading(true)
        transactionFetchService.getManualReconciledBankDetails().then(res => {
            if (res.data !== null) {
                setManualReconcileList(res.data.results)
                setTableLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_PENDING_TRANSACTION_LIST_ERROR).then();
                setTableLoading(false)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
            setTableLoading(false)

        })
    }

    const fetchManualMappedCustomerInvestList = (bankId: number) => {
        setTableLoading(true)
        transactionFetchService.getManualMappedCustomerInvestRequests(bankId).then(res => {
            if (res.data !== null) {
                setCustomerRequestList(res.data.results)
                setTableLoading(false)
                setColumnHide(true)
                setPendingTransOpen(true);
            } else {
                message.error(MSG_FAILED_TO_FETCH_MANUALLY_MAPPED_CUSTOMER_REQUEST_ERROR).then();
                setTableLoading(false)
            }

        }, (reason) => {
            ErrorHandler.handleError(reason);
            setTableLoading(false)

        })
    }

    const onAuthorize = (type: string) => {
        if (BULK === type && selectedRecordIdList.length <= 0) {
            message.warning("Please select records before authorize")
        } else {

            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure?, Do you want to authorize this ${type === INDIVIDUAL ? '' : 'selected'} manual reconciliation${type === INDIVIDUAL ? '?' : 's?'}`,
                okText: 'Yes',
                cancelText: 'No',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    let idList: number[] = type === INDIVIDUAL ? [selectedRecordList[0].id] : selectedRecordIdList;
                    authorizeManualReconciliation(idList)
                },
                onCancel() {
                }
            });
        }

    }
    const handleRejectReasonCancel = () => {
        setRejectReasonModalOpen(false)
    }

    const onReject = () => {
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to reject manual reconciliation?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setRejectReasonModalOpen(true)
            },
            onCancel() {
                handleRejectReasonCancel()
            }
        });
    }

    const rejectRequest = (value: any) => {
        setSelectedRecordIdList((prevNumbers) =>
            prevNumbers.filter(id => id !== selectedRecordList[0].id)
        );
        rejectManualReconciliation(value.rejectReason)
    }

    const rejectManualReconciliation = (rejectReason: string) => {
        setSpinning(true)
        let manualReconciliationDto = {
            bankExcelDetailId: selectedRecordList[0].id,
            reconciliationRejectReason: rejectReason
        } as ManualReconciliationDto

        transactionService.rejectManualReconciliation(manualReconciliationDto).then((res) => {
            if (res.data.results) {
                handleRejectReasonCancel()
                onClosePendingTransDrawer()
                fetchManualReconciliationList()
                message.success(MSG_MANUAL_RECONCILE_REJECT_SUCCESS)
                setSpinning(false)
            } else {
                message.error(MSG_MANUAL_RECONCILE_REJECTION_FAILURE)
                setSpinning(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)

        })
    }

    const authorizeManualReconciliation = (bankExcelIds: number[]) => {
        setSpinning(true)
        let manualReconciliationDto = {
            bankExcelIds: bankExcelIds
        } as ManualReconciliationDto

        transactionService.authorizeManualReconciliation(manualReconciliationDto).then((res) => {
            if (res.data.results) {
                onClosePendingTransDrawer()
                fetchManualReconciliationList()
                message.success(MSG_MANUAL_RECONCILE_AUTHORIZE_SUCCESS)
                setSpinning(false)
            } else {
                message.error(MSG_MANUAL_RECONCILE_AUTHORIZE_FAILURE)
                setSpinning(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setSpinning(false)

        })
    }
    const onClosePendingTransDrawer = () => {
        setSelectedRecordList([])
        setColumnHide(false)
        setPendingTransOpen(false);
    };

    const onView = (rec: ReconciliationTableDataDto) => {
        fetchManualMappedCustomerInvestList(rec.id as number);
        setSelectedRecordList([rec])

    }


    const showTransReceiptModal = (record: AccountWiseFundDetailDto) => {
        setCustomerRequestLoading(true)
        documentService.getUploadDocumentListByTypeAndUploadedDocId(toNumber(record.jobNumber), record.transactionDocumentId as number, [DOC_CODE_INVEST_TRANSACTION_DOCUMENT]).then(res => {
            if (res.data.status == 'SUCCESS') {
                viewOriginalDocument(res.data.results[0].uploadDocumentDetailDto);
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setCustomerRequestLoading(false)
            }
        }, (reason) => {
            message.warning(MSG_UNABLE_TO_FETCH_INVEST_DOCUMENTS_ERROR).then();
            setCustomerRequestLoading(false)
        });
    }

    const viewOriginalDocument = (document: UploadedDocumentDetailDto) => {
        documentService.viewOriginalDocument(document.uploadDocumentDetailId.toString()).then(res => {
            if (res.data !== null) {
                setIsTransReceiptModalOpen(true);
                setDocURL(res.data.results)
                setDocumentName(document.originalDocumentName)
                setDocType(CommonFunction.checkDocumentContentType(res.data.results))
                setCustomerRequestLoading(false)
            } else {
                setCustomerRequestLoading(false)
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setCustomerRequestLoading(false)
        })
    };

    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }

    const handleTransReceiptModalCancel = () => {
        setIsTransReceiptModalOpen(false);
    };
    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };

    return (
        <div className={'invest-recon-auth-page'}>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <img style={{width:24,height:24}}
                                 src={recon_auth} alt=""/>
                        </div>
                        Invest Reconciliation Authorization
                    </h2>
                </Col>
            </Row>
            <Row gutter={[16, 16]} className='margin_top_30'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Table scroll={{x: 'max-content'}} columns={columns} dataSource={manualReconcileList}
                           rowSelection={{...rowSelection}} rowKey={(record) => record.id}
                           loading={isTableLoading}/>

                </Col>

            </Row>
            <Row gutter={[16, 20]} className='margin_top_20'>
                <Col span={24} className={'recon-btn-row'} style={{borderTop: 'none'}}>
                    <Button type="primary" size={'large'} onClick={() => onAuthorize(BULK)}>
                        Authorize
                    </Button>
                </Col>
            </Row>
            <Drawer className={'recon-drawer recon-drawer-custom-width custom-invest-add-btn-size'} size={'large'}
                    title={<span>Reconciliation Details</span>}
                    destroyOnClose={true}
                    onClose={onClosePendingTransDrawer} open={openPendingTransDrawer}>
                <Spin spinning={isSpinning}>
                    <Row gutter={[16, 20]}>
                        <Col span={24}>
                            <Card size={'small'} title={'Bank Record'}>
                                <Table scroll={{x: 'max-content'}} size="small" columns={columns}
                                       dataSource={selectedRecordList}
                                       pagination={{position: ['none', 'none']}}></Table>
                            </Card>
                        </Col>
                        <Col span={24}>
                            <Card title={"Customer Requests"}>
                                <Table className={'recon-customer-requests-table'} scroll={{x: 'max-content'}}
                                       loading={isCustomerRequestLoading}
                                       columns={customerRequestsColumns} dataSource={customerRequestList}/>
                            </Card>
                        </Col>
                        <Col span={24} className='drawer-manual-recon-btn'>
                            <Space style={{float: 'right'}}>
                                <Button onClick={onReject}>
                                    Reject
                                </Button>
                                <Button type='primary' onClick={() => onAuthorize(INDIVIDUAL)}>Authorize</Button>

                            </Space>
                        </Col>
                    </Row>
                </Spin>
            </Drawer>
            <Modal title="Reject Reason"
                   open={isRejectReasonModalOpen}
                   destroyOnClose={true}
                   maskClosable={false}
                   footer={null}
                   onCancel={handleRejectReasonCancel}
            >
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form
                            layout={"vertical"}
                            initialValues={{remember: true}}
                            onFinish={rejectRequest}
                        >
                            <Form.Item
                                name={"rejectReason"}
                                label={"Reject Reason"}
                                rules={[{
                                    required: true,
                                    message: 'Please enter reject reason'
                                }]}>
                                <TextArea showCount placeholder="Please enter reject reason" maxLength={255}
                                          bordered={true}/>
                            </Form.Item>
                            <Form.Item>
                                <Space style={{float: 'right'}}>
                                    <Button onClick={handleRejectReasonCancel}>
                                        Cancel
                                    </Button>
                                    <Button htmlType="submit"
                                            type="primary">
                                        Submit
                                    </Button>
                                </Space>
                            </Form.Item>


                        </Form>
                    </Col>
                </Row>

            </Modal>
            <Modal title={
                       <div
                           style={{
                               width: '100%',
                               cursor: 'move',
                           }}
                           onMouseOver={() => {
                               if (disabled) {
                                   setDisabled(false);
                               }
                           }}
                           onMouseOut={() => {
                               setDisabled(true);
                           }}
                           onFocus={() => {
                           }}
                           onBlur={() => {
                           }}
                           // end
                       >
                           {documentName}
                       </div>
                   }
                   open={isTransReceiptModalOpen}
                   destroyOnClose={true}
                   maskClosable={false}
                   onCancel={handleTransReceiptModalCancel}
                   centered
                // className='dashboard-account-open-modal'
                   className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                   width={docType == PREVIEW_DOC_TYPES.PDF ? 600 : 550}
                   footer={[
                       <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                               htmlType="submit" onClick={() => download(docURL, documentName)}>
                           Download
                       </Button>]}
                   modalRender={(modal: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined) => (
                       <Draggable
                           disabled={disabled}
                           bounds={bounds}
                           nodeRef={draggleRef}
                           onStart={(event, uiData) => onStart(event, uiData)}
                       >
                           <div ref={draggleRef}>{modal}</div>
                       </Draggable>
                   )}
            >


                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </div>


    )

}
export default InvestReconciliationAuth;

